/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface OrgAccess {
    /**
     * org id for the access
     */
    orgId: string;

    /**
     * access level
     */
    access: OrgAccess.Access;

}

export namespace OrgAccess {

    export enum Access {
            NONE = <any> 'NONE',
            NORMAL = <any> 'NORMAL',
            ADMIN = <any> 'ADMIN'
    }
}



// WEBPACK FOOTER //
// ./src/common/api/models/OrgAccess.ts